import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  CardActions,
  Typography,
  useTheme,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useSelector } from "react-redux";
import UserProfileIcon from "../../../../assets/icons/UserProfile.png"; // Asegúrate de tener esta ruta correcta
import toast from "react-hot-toast";

const CardServiceProvider = ({ serviceProvider }) => {
  const theme = useTheme();
  const [formatRole, setFormatRole] = useState(serviceProvider?.role);
  const { status, firstName } = useSelector((state) => state.userReducer);
  const { membershipStatus } = useSelector((state) => state.membershipReducer);

  useEffect(() => {
    const roles = {
      Coach: "Entrenador",
      Nutricionist: "Nutriólogo",
      Psicology: "Psicólogo",
      Physiotherapy: "Fisioterapeuta",
    };

    setFormatRole(roles[serviceProvider?.role] || "Prestador de Servicio");
  }, [serviceProvider]);

  const handleContact = () => {
    try {
      // Validación de estado de cuenta
      if (status !== "active" || membershipStatus !== "active") {
        const errorMessage =
          status !== "active"
            ? "Completa tu información"
            : "Contrata una membresia";

        toast.error(
          `Tu cuenta no esta completa. \n ${status !== "active" ? "Completa tu información" : membershipStatus !== "active" && "Contrata una membresia."}`
        );
        return;
      }

      // Formatear número y mensaje para WhatsApp
      const phoneNumber =
        serviceProvider?.phoneNumber?.replace(/\+/g, "") ?? "";
      if (!phoneNumber) {
        console.error("Número de teléfono no disponible");
        return;
      }

      const message = `!Hola¡, soy ${firstName}, Quiero más información sobre su servicio en Radaria.`;
      const encodedMessage = encodeURIComponent(message);

      // Abrir enlace de WhatsApp
      window.open(
        `https://wa.me/${phoneNumber}?text=${encodedMessage}`,
        "_blank"
      );
    } catch (error) {
      toast.error("En estos momentos su contacto no esta disponible.");
    }
  };

  return (
    <Card
      sx={{
        width: 300,
        p: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[3],
        borderRadius: theme.shape.borderRadius,
        transition: "transform 0.3s, box-shadow 0.3s",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: theme.shadows[6],
        },
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
          pb: 2,
          width: "100%",
        }}
      >
        <Avatar
          sx={{
            width: 100,
            height: 100,
            mb: 2,
            // bgcolor: theme.palette.grey[200],
          }}
          src={serviceProvider?.urlImg || UserProfileIcon}
          alt={`${serviceProvider?.firstName || "Usuario"} avatar`}
        />

        <Typography variant="h6" component="div" textAlign="center">
          {serviceProvider?.firstName || "Nombre no disponible"}
        </Typography>

        <Typography
          variant="subtitle1"
          color="text.secondary"
          sx={{ fontWeight: 500 }}
        >
          {formatRole}
        </Typography>
      </CardContent>

      <CardActions sx={{ width: "100%", justifyContent: "center" }}>
        <Button
          variant="outlined"
          color="white"
          startIcon={<WhatsAppIcon sx={{ color: "#e7ef7d" }} />}
          onClick={handleContact}
        >
          Contactar
        </Button>
      </CardActions>
    </Card>
  );
};

export default CardServiceProvider;
